
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/integrations/amo",
      function () {
        return require("private-next-pages/[locale]/integrations/amo/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/integrations/amo"])
      });
    }
  